var _defs, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalExplorador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Medalla_Explorador",
    "data-name": "Medalla Explorador",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194,
    height: 167,
    viewBox: "0 0 194 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86265",
    "data-name": "Rect\\xE1ngulo 86265",
    width: 194,
    height: 167,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19206",
    "data-name": "Grupo 19206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19205",
    "data-name": "Grupo 19205",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107535",
    "data-name": "Trazado 107535",
    d: "M38.875,140.6l2.477,8.268h-.009l.008.024-31.083,9.1,1.174-13.346-7.887-9.056,17.533-5.132-5.8-16.836s1.836-.722,5.244-1.835a81.617,81.617,0,1,1,153.092.046q2.547.859,5.1,1.793l-5.581,16.853,17.482,5.338-7.81,9.87,1.378,12.964-30.872-9.427.007-.026h-.007l.121-.408,2.484-8.821A81.623,81.623,0,0,1,40.7,142.4q-.925-.886-1.824-1.8Z",
    transform: "translate(-0.006 -0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107536",
    "data-name": "Trazado 107536",
    d: "M38.875,140.6l2.477,8.268h-.009l.008.024-31.083,9.1,1.174-13.346-7.887-9.056,17.533-5.132-5.8-16.836s1.836-.722,5.244-1.835a81.617,81.617,0,1,1,153.092.046q2.547.859,5.1,1.793l-5.581,16.853,17.482,5.338-7.81,9.87,1.378,12.964-30.872-9.427.007-.026h-.007l.121-.408,2.484-8.821A81.623,81.623,0,0,1,40.7,142.4q-.925-.886-1.824-1.8Z",
    transform: "translate(-0.006 -0.008)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107537",
    "data-name": "Trazado 107537",
    d: "M175.467,84.393A76.846,76.846,0,1,1,98.621,7.713a76.763,76.763,0,0,1,76.845,76.68",
    transform: "translate(-0.036 -0.029)",
    fill: "#3c3f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107538",
    "data-name": "Trazado 107538",
    d: "M148.613,34.547a70.607,70.607,0,1,1-99.962,0,70.421,70.421,0,0,1,99.962,0l0,0",
    transform: "translate(-0.046 -0.053)",
    fill: "#cad79f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107539",
    "data-name": "Trazado 107539",
    d: "M169.284,85.659A70.664,70.664,0,0,0,27.979,83.173q-.022,1.243,0,2.486c63.535,29.665,63.007-38.227,141.305,0",
    transform: "translate(-0.046 -0.053)",
    fill: "#e4ebcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107540",
    "data-name": "Trazado 107540",
    d: "M133.762,132l-2.113-1.207-2.2,1.05.5-2.38-1.681-1.757,2.421-.261,1.16-2.138,1,2.219,2.4.437-1.806,1.632Z",
    transform: "translate(-0.213 -0.478)",
    fill: "#ce2017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107541",
    "data-name": "Trazado 107541",
    d: "M139.069,119.674a1.692,1.692,0,1,1,1.694,1.687h0a1.691,1.691,0,0,1-1.691-1.687",
    transform: "translate(-0.23 -0.45)",
    fill: "#29304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107542",
    "data-name": "Trazado 107542",
    d: "M63.727,132l2.11-1.207,2.2,1.05-.5-2.38,1.681-1.757-2.421-.261-1.157-2.14-1,2.219-2.4.437,1.808,1.632Z",
    transform: "translate(-0.103 -0.478)",
    fill: "#ce2017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107543",
    "data-name": "Trazado 107543",
    d: "M58.422,119.674a1.69,1.69,0,1,0-1.69,1.687h0a1.688,1.688,0,0,0,1.689-1.686Z",
    transform: "translate(-0.091 -0.45)",
    fill: "#29304a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107544",
    "data-name": "Trazado 107544",
    d: "M98.787,145.8l-1.7-3.44-3.8-.552,2.752-2.679-.65-3.786,3.4,1.785,3.4-1.785-.65,3.786,2.752,2.679-3.8.552Z",
    transform: "translate(-0.155 -0.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107545",
    "data-name": "Trazado 107545",
    d: "M115.789,65.852a24.43,24.43,0,1,1-24.43-24.378,24.4,24.4,0,0,1,24.43,24.378",
    transform: "translate(-0.111 -0.158)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107546",
    "data-name": "Trazado 107546",
    d: "M64.965,64.15c.214-1.28.387-2.568.647-3.838A25.36,25.36,0,0,1,69.4,51.379a1.31,1.31,0,0,1,1.809-.5,1.341,1.341,0,0,1,.394,1.884,47.424,47.424,0,0,0-2.48,4.929A23.691,23.691,0,0,0,95.093,89.368a23.228,23.228,0,0,0,16.048-10.28,23.751,23.751,0,0,0-1.425-28.157,23.07,23.07,0,0,0-13.461-8.138,23.409,23.409,0,0,0-16.979,2.761c-.376.217-.739.461-1.124.659a1.3,1.3,0,0,1-1.778-.4A1.274,1.274,0,0,1,76.832,44c1.394-.795,2.793-1.6,4.256-2.252,2.558-1.146,8.4-2.072,8.569-2.109h3.266c1.392.218,2.811.325,4.168.672,10.708,2.742,17.485,9.462,20.023,20.208a24.807,24.807,0,0,1-2.105,17.032,1.035,1.035,0,0,0,.275,1.479c.688.6,1.3,1.277,1.951,1.922a3.163,3.163,0,0,1,.907,3.273.681.681,0,0,0,.123.553c.739.794,1.507,1.562,2.248,2.32,1.1-.523,1.6-.511,2.072.017.446.5.432,1.035-.078,1.889.15.157.307.331.472.5,2.062,2.058,4.1,4.141,6.195,6.163A8.033,8.033,0,0,1,131.854,100v1.435a1.056,1.056,0,0,0-.1.227,5.027,5.027,0,0,1-2.134,3.488,19,19,0,0,1-2.729,1.238h-1.438A7.807,7.807,0,0,1,121.2,103.8c-2.063-2.118-4.178-4.183-6.267-6.276a3.751,3.751,0,0,1-.36-.488c-1.093.53-1.674.516-2.128.013-.438-.485-.423-1.045.084-1.909-.795-.795-1.6-1.612-2.423-2.4a.573.573,0,0,0-.463-.042,3.144,3.144,0,0,1-3.278-.9c-.695-.689-1.407-1.363-2.07-2.08a.818.818,0,0,0-1.158-.205,24.978,24.978,0,0,1-11.429,2.767A26.376,26.376,0,0,1,65.4,70.683c-.208-1.079-.294-2.182-.436-3.274Zm51.351,31.093q3.423,3.41,6.844,6.815a12.007,12.007,0,0,0,1.142,1.067,2.906,2.906,0,0,0,3.194.335,3.04,3.04,0,0,0,.729-5.028c-2.443-2.478-4.921-4.921-7.387-7.377a.991.991,0,0,0-.191-.134l-4.331,4.322m-3.082-14.567a27.086,27.086,0,0,1-7.175,7.152c.781.767,1.507,1.48,2.232,2.195a.53.53,0,0,0,.849-.02c.352-.354.707-.7,1.06-1.057q2.559-2.551,5.119-5.1c.283-.282.518-.574.156-.94-.728-.739-1.471-1.463-2.241-2.227m-1.14,10.165,2.345,2.335,4.135-4.118-2.339-2.36-4.141,4.143",
    transform: "translate(-0.108 -0.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107547",
    "data-name": "Trazado 107547",
    d: "M110.961,66.009a19.6,19.6,0,1,1-19.555-19.56,19.645,19.645,0,0,1,19.555,19.56M91.447,82.945A16.945,16.945,0,1,0,74.384,66.067,17.013,17.013,0,0,0,91.447,82.945",
    transform: "translate(-0.119 -0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107548",
    "data-name": "Trazado 107548",
    d: "M73.555,49.582a1.309,1.309,0,0,1-1.221-1.346,1.386,1.386,0,0,1,1.4-1.258,1.29,1.29,0,0,1,1.205,1.356,1.324,1.324,0,0,1-1.389,1.248",
    transform: "translate(-0.12 -0.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107549",
    "data-name": "Trazado 107549",
    d: "M116.4,95.439l4.331-4.322a.989.989,0,0,1,.192.134c2.465,2.456,4.943,4.9,7.386,7.378a3.039,3.039,0,0,1-.728,5.027,2.906,2.906,0,0,1-3.195-.335,12.128,12.128,0,0,1-1.142-1.067q-3.423-3.4-6.844-6.815",
    transform: "translate(-0.193 -0.347)",
    fill: "#f8b8d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107550",
    "data-name": "Trazado 107550",
    d: "M113.3,80.832c.771.764,1.513,1.489,2.241,2.227.362.368.127.658-.156.94q-2.562,2.548-5.119,5.1c-.353.353-.708.7-1.06,1.057a.531.531,0,0,1-.849.02c-.725-.714-1.452-1.428-2.232-2.2a27.086,27.086,0,0,0,7.175-7.152",
    transform: "translate(-0.176 -0.308)",
    fill: "#fed5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107551",
    "data-name": "Trazado 107551",
    d: "M112.172,91.021l4.141-4.143,2.339,2.36-4.135,4.118-2.345-2.335",
    transform: "translate(-0.186 -0.331)",
    fill: "#f8b8d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107552",
    "data-name": "Trazado 107552",
    d: "M91.452,82.955a16.945,16.945,0,1,1,16.9-17.043,17.015,17.015,0,0,1-16.9,17.043",
    transform: "translate(-0.123 -0.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107553",
    "data-name": "Trazado 107553",
    d: "M103.712,65.824A12.38,12.38,0,1,1,91.331,53.47a12.367,12.367,0,0,1,12.38,12.354",
    transform: "translate(-0.131 -0.204)",
    fill: "#f8b8d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107554",
    "data-name": "Trazado 107554",
    d: "M100.384,65.885a9,9,0,1,1-9-8.98,8.989,8.989,0,0,1,9,8.98",
    transform: "translate(-0.137 -0.217)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107555",
    "data-name": "Trazado 107555",
    d: "M77.043,64.558l.033.339c0,.043.012.086.014.1a14.255,14.255,0,0,1,24.118-9.442,13.947,13.947,0,0,1,4.371,9.478c.01-.065.022-.141.035-.218v1.948c-.012-.047-.023-.095-.034-.142A14.283,14.283,0,0,1,92.19,80.035l.282.036H89.948l.514-.037a13.99,13.99,0,0,1-9.227-4.162A13.723,13.723,0,0,1,77.1,66.63c0,.044-.009.075-.012.107-.015.16-.029.321-.044.481Zm1.914,1.236A12.371,12.371,0,1,0,91.331,53.479,12.33,12.33,0,0,0,78.957,65.795",
    transform: "translate(-0.128 -0.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107556",
    "data-name": "Trazado 107556",
    d: "M91.35,75.822A10.017,10.017,0,0,1,83.71,72.3a9.687,9.687,0,0,1-1.925-3.488,9.1,9.1,0,0,1-.41-2.111c-.022-.332-.047-.663-.044-1a9.792,9.792,0,0,1,.343-2.47c.039-.144.079-.29.128-.431a.952.952,0,0,1,1.834.5c-.089.389-.2.774-.271,1.166a7.631,7.631,0,0,0-.093,2.045,7.893,7.893,0,0,0,.543,2.3,8.053,8.053,0,0,0,2.836,3.6,7.45,7.45,0,0,0,3.1,1.332,7.955,7.955,0,0,0,7.9-2.871,7.419,7.419,0,0,0,1.6-3.364,8.085,8.085,0,0,0-6.389-9.6,8.02,8.02,0,0,0-3.937.216.935.935,0,0,1-1.064-.317.948.948,0,0,1,.477-1.506,8.577,8.577,0,0,1,1.546-.358,10.088,10.088,0,0,1,1.826-.094,9.736,9.736,0,0,1,2.737.485,9.872,9.872,0,0,1,2.748,1.409,10.075,10.075,0,0,1,2.245,2.24,9.909,9.909,0,0,1,1.7,3.866,9.376,9.376,0,0,1,.2,2.453,10.017,10.017,0,0,1-7.808,9.276,9.719,9.719,0,0,1-2.179.243",
    transform: "translate(-0.135 -0.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107557",
    "data-name": "Trazado 107557",
    d: "M90.383,70.848c.009-.295.007-.288-.265-.39a5.673,5.673,0,0,1-.664-.287.939.939,0,0,1,.389-1.771,1.533,1.533,0,0,1,.484.1c.159.048.306.129.463.183a.942.942,0,0,0,1.2-.482.928.928,0,0,0-.448-1.228c-.317-.159-.653-.283-.981-.42a2.835,2.835,0,0,1-.274-5.2.159.159,0,0,0,.107-.169,5.1,5.1,0,0,1,.023-.71.927.927,0,0,1,.927-.806.938.938,0,0,1,.936.825A3.211,3.211,0,0,1,92.3,61c0,.121.045.159.151.2a7.694,7.694,0,0,1,.793.319.927.927,0,0,1,.477,1.061.941.941,0,0,1-.908.719,1.972,1.972,0,0,1-.5-.122c-.208-.064-.405-.165-.617-.208a.9.9,0,0,0-1.01.588.916.916,0,0,0,.427,1.15c.33.16.675.292,1.016.43a2.892,2.892,0,0,1,1.619,1.538A2.824,2.824,0,0,1,92.5,70.3a.305.305,0,0,0-.2.335,3.117,3.117,0,0,1-.021.6.947.947,0,0,1-.942.8.937.937,0,0,1-.919-.8c-.018-.126-.023-.252-.034-.378",
    transform: "translate(-0.147 -0.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107558",
    "data-name": "Trazado 107558",
    d: "M84,59.455a.95.95,0,0,1,.934-.953.954.954,0,1,1-.934.953",
    transform: "translate(-0.139 -0.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107559",
    "data-name": "Trazado 107559",
    d: "M154.544,116.055l-.653-.364a63.519,63.519,0,1,0-111.283-.4l-.657.359a64.269,64.269,0,1,1,112.593.4",
    transform: "translate(-0.056 -0.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107560",
    "data-name": "Trazado 107560",
    d: "M10.557,133.892l29.259-8.546,6.318,21.037-29.259,8.543,1.11-12.534Z",
    transform: "translate(-0.017 -0.478)",
    fill: "#cedba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107561",
    "data-name": "Trazado 107561",
    d: "M31.346,141.427s5.43-1.846,7.258-2.4c1.226-.37,4.939-1.363,4.939-1.363l2.626,8.746Z",
    transform: "translate(-0.052 -0.525)",
    fill: "#6a8427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107562",
    "data-name": "Trazado 107562",
    d: "M186.883,134.1l-29.063-8.852-6.052,21.442,29.06,8.851-1.3-12.173Z",
    transform: "translate(-0.251 -0.477)",
    fill: "#cedba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107563",
    "data-name": "Trazado 107563",
    d: "M166.345,141.434s-5.124-1.956-6.954-2.51c-1.223-.37-4.86-1.478-4.86-1.478l-2.762,9.265Z",
    transform: "translate(-0.251 -0.524)",
    fill: "#6a8427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107564",
    "data-name": "Trazado 107564",
    d: "M31.33,141.292l-9.707-28.125s74-29.058,153.845,0l-9.34,28.125s-58.826-25.4-134.8,0",
    transform: "translate(-0.036 -0.382)",
    fill: "#91ac49"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(49.855 122.727) rotate(-15.3)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "X",
    transform: "matrix(0.979, -0.204, 0.204, 0.979, 59.423, 120.179)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "translate(69.144 118.214) rotate(-8.411)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(78.958 116.829) rotate(-5.19)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "matrix(1, -0.031, 0.031, 1, 88.145, 116.023)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(99.368 115.751) rotate(1.911)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(109.934 116.16) rotate(5.486)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "D",
    transform: "matrix(0.988, 0.158, -0.158, 0.988, 120.452, 117.227)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    "data-name": "O",
    transform: "translate(130.866 118.933) rotate(12.73)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    id: "R-2",
    "data-name": "R",
    transform: "translate(141.796 121.469) rotate(16.357)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalExplorador);
export default __webpack_public_path__ + "static/media/medal-explorador.ab368123cca2450fdfcb5bc3d74c5456.svg";
export { ForwardRef as ReactComponent };